import {ref} from 'vue';
import {clientCompanyEndpoints} from '@registry';
import {defineStore} from 'pinia';
import {useErrorHandler} from '@malt/utils';
import {GetClientCompanyMembersRoleEnum, type ClientCompanyMemberResource} from '@api';

export const useCompanyInfoStore = defineStore('company-info-store', () => {
    const {handleUnknownError} = useErrorHandler();

    const companyAdmins = ref<ClientCompanyMemberResource[]>();
    const companyMembers = ref<ClientCompanyMemberResource[]>();

    async function getCompanyAdmins(companyId: string) {
        try {
            const response = await clientCompanyEndpoints.getClientCompanyMembers({
                companyId,
                role: GetClientCompanyMembersRoleEnum.Admin,
            });
            companyAdmins.value = response.members;
        } catch (e) {
            handleUnknownError(e, {showSnackbar: false});
            companyAdmins.value = null as unknown as ClientCompanyMemberResource[];
            return undefined;
        }
    }

    async function getCompanyMembers(companyId: string) {
        try {
            const response = await clientCompanyEndpoints.getClientCompanyMembers({
                companyId,
                role: GetClientCompanyMembersRoleEnum.All,
            });
            companyMembers.value = response.members;
        } catch (e) {
            handleUnknownError(e, {showSnackbar: false});
            companyMembers.value = null as unknown as ClientCompanyMemberResource[];
            return undefined;
        }
    }

    return {
        getCompanyAdmins,
        companyAdmins,
        getCompanyMembers,
        companyMembers,
    };
});
